// API service modules.
import { api } from './api.js';

export const AuthAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  me: () => api.get('/auth/me'),
  getProfile: () => api.get('/auth/profile'),
  updateProfile: (data) => api.patch('/auth/profile', data),
  changePassword: (currentPassword, newPassword) => api.post('/auth/change-password', { currentPassword, newPassword }),
};

export const BranchAPI = {
  list: (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return api.get(`/branches${q ? `?${q}` : ''}`);
  },
  listPublic: () => api.get('/branches/public'),
  get: (id) => api.get(`/branches/${id}`),
  getDetail: (id) => api.get(`/branches/${id}/detail`),
  create: (data) => api.post('/branches', data),
  update: (id, data) => api.patch(`/branches/${id}`, data),
  del: (id) => api.del(`/branches/${id}`),
};

export const ServiceAPI = {
  list: (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return api.get(`/branch-srvs${q ? `?${q}` : ''}`);
  },
  listAvailableForBeneficiary: () => api.get('/branch-srvs/available-for-me'),
  get: (id) => api.get(`/branch-srvs/${id}`),
  create: (data) => api.post('/branch-srvs', data),
  update: (id, data) => api.patch(`/branch-srvs/${id}`, data),
  setInstructors: (id, instructor_ids) => api.put(`/branch-srvs/${id}/instructors`, { instructor_ids }),
  addInstructor: (id, instructor_id) => api.post(`/branch-srvs/${id}/instructors`, { instructor_id }),
  removeInstructor: (id, instructorId) => api.del(`/branch-srvs/${id}/instructors/${instructorId}`),
};

export const UserAPI = {
  list: (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return api.get(`/users${q ? `?${q}` : ''}`);
  },
  get: (id) => api.get(`/users/${id}`),
  create: (data) => api.post('/users', data),
  update: (id, data) => api.patch(`/users/${id}`, data),
  resetPassword: (id, newPassword) => api.post(`/users/${id}/reset-password`, newPassword ? { newPassword } : {}),
};

export const InstructorAPI = {
  list: (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return api.get(`/instructors${q ? `?${q}` : ''}`);
  },
  get: (id) => api.get(`/instructors/${id}`),
  create: (data) => api.post('/instructors', data),
  update: (id, data) => api.patch(`/instructors/${id}`, data),
};

export const RegistrationRequestAPI = {
  submitPublic: (data) => api.post('/registration-requests/public', data),
  list: (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return api.get(`/registration-requests${q ? `?${q}` : ''}`);
  },
  approve: (id, { review_notes } = {}) => {
    const body = {};
    if (review_notes !== undefined) body.review_notes = review_notes;
    return api.post(`/registration-requests/${id}/approve`, body);
  },
  reject: (id, review_notes) => api.post(`/registration-requests/${id}/reject`, { review_notes }),
};

export const NotificationAPI = {
  list: (unreadOnly = false) => api.get(`/notifications${unreadOnly ? '?unread=1' : ''}`),
};

export const SessionAPI = {
  list: (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return api.get(`/meetings${q ? `?${q}` : ''}`);
  },
  listAvailable: () => api.get('/meetings/available'),
  get: (id) => api.get(`/meetings/${id}`),
  create: (data) => api.post('/meetings', data),
  update: (id, data) => api.patch(`/meetings/${id}`, data),
  cancel: (id) => api.post(`/meetings/${id}/cancel`),
  complete: (id) => api.post(`/meetings/${id}/complete`),
};

export const EnrollmentAPI = {
  listBySession: (sessionId) => api.get(`/enrollments/meeting/${sessionId}`),
  listMine: () => api.get('/enrollments/mine'),
  enroll: (sessionId) => api.post('/enrollments', { session_id: sessionId }),
  cancel: (id) => api.post(`/enrollments/${id}/cancel`),
  recordAttendance: (id, status) => api.patch(`/enrollments/${id}/attendance`, { status }),
};

export const AuditAPI = {
  notifications: (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return api.get(`/audit/notifications${q ? `?${q}` : ''}`);
  },
  summary: (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return api.get(`/audit/summary${q ? `?${q}` : ''}`);
  },
};
